import React from 'react';
import { useSelector } from 'react-redux';

import { academyTopicSelector } from 'features/classCreation';
import ClassDateTimeInput from '../ClassDateTimeInput';
import styles from './ScheduleConfirmationClassRow.module.scss';
import TableCell from 'components/TableCell';
import TableRow from 'components/TableRow';

function ScheduleConfirmationClassRow({ cls }) {
  const {
    primaryInstructor,
    secondaryInstructor,
    otherInstructors,
    dateOfTopic,
  } = useSelector((state) => academyTopicSelector(state, cls.academy_topic.id));

  return (
    <TableRow className={styles.root}>
      <TableCell>{cls.academy_topic.title}</TableCell>
      <TableCell>{cls.academy_topic.junction_number || '-'}</TableCell>
      <TableCell>{primaryInstructor?.label || '-'}</TableCell>
      <TableCell>{secondaryInstructor?.label || '-'}</TableCell>
      <TableCell>
        {otherInstructors.map((o) => o.label).join(', ') || '-'}
      </TableCell>
      <TableCell>
        <ClassDateTimeInput
          cls={cls}
          dateOfTopic={dateOfTopic}
        />
      </TableCell>
    </TableRow>
  );
}

export default ScheduleConfirmationClassRow;
